var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHurdleWinOffDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "100%",
    height: "100%",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_1_copy_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#324252",
    stroke: "none",
    d: " M 4.8 2.35 L 16.5 9.55 29.55 4.7 17.8 -2.6 4.8 2.35 M 14.55 22.85 L 29.15 17.3 16.5 9.55 2.05 15.15 2.7 15.6 14.55 22.85 M -20.95 1 L -9.8 7.9 4.8 2.35 -6.35 -4.5 -20.95 1 M -17.35 -11.3 L -6.35 -4.5 6.7 -9.5 -4.25 -16.2 -17.35 -11.3 M -17.35 -11.3 L -27.75 -17.65 -42.4 -12.1 -31.95 -5.65 -17.35 -11.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B6174",
    stroke: "none",
    d: " M 16.5 9.55 L 29.15 17.3 42.45 12.55 29.55 4.7 16.5 9.55 M -17.35 -11.3 L -31.95 -5.65 2.7 15.6 2.05 15.15 16.5 9.55 4.8 2.35 -9.8 7.9 -20.95 1 -6.35 -4.5 -17.35 -11.3 M -14.5 -22.85 L -27.75 -17.65 -17.35 -11.3 -4.25 -16.2 -14.5 -22.85 M 17.8 -2.6 L 6.7 -9.5 -6.35 -4.5 4.8 2.35 17.8 -2.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0099CC",
    stroke: "none",
    d: " M 6.7 -9.5 L 6.75 -9.5 -4.25 -16.25 -4.25 -16.2 6.7 -9.5 M 17.85 -2.65 L 17.8 -2.6 29.55 4.7 29.6 4.6 17.85 -2.65 Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Symbol_1_copy_0_Layer0_0_1_STROKES",
    stroke: "#324252",
    strokeWidth: 2,
    strokeLinejoin: "miter",
    strokeLinecap: "round",
    strokeMiterlimit: 3,
    fill: "none",
    d: " M 42.45 12.55 L 29.15 17.3 14.55 22.85 M -42.4 -12.1 L -27.75 -17.65 -14.5 -22.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Symbol_1_copy_0_Layer0_0_2_STROKES",
    stroke: "#324252",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 29.55 4.7 L 42.45 12.55 M 14.55 22.85 L 2.7 15.6 -31.95 -5.65 -42.4 -12.1 M -14.5 -22.85 L -4.25 -16.2 M 6.7 -9.5 L 17.8 -2.6 29.55 4.7 M -4.25 -16.2 L 6.7 -9.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer0_0_1_STROKES",
    stroke: "#324252",
    strokeWidth: 6,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "none",
    d: " M 16.75 36.3 L 16.75 6.15 53.4 31.8 53.4 62.6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 0.860504150390625, 0, -0.1781463623046875, 0.860504150390625, 37.55,50.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_copy_0_Layer0_0_FILL"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_copy_0_Layer0_0_1_STROKES"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_copy_0_Layer0_0_2_STROKES"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 0,0) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_1_STROKES"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurdleWinOffDark);
export default __webpack_public_path__ + "static/media/hurdle-win-off-dark.9797500c98ea2deb59e10c3b4e30bb71.svg";
export { ForwardRef as ReactComponent };